
import { take } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { log } from 'util';
import { AuthService } from '../services/auth.service';

import * as CartActions from '../store/cart/cart.actions';
import * as fromApp from '../store/app.reducers';
import { CartNode } from '../model/cart.model';
import { environment } from '../../environments/environment';
import { HeadersEnum, ParamsKeys, ParamsValues, RestURLsEnum } from '../model/http-request-enums';
import { isUndefinedOrNull } from '../utils/util-functions';
import { CartConstants } from '../constants/application-constants';


@Injectable()
export class CartProvider {
    csCartUrl = environment.csBaseURL + RestURLsEnum.CART_BASE;
    header = new HttpHeaders().set(ParamsKeys.ACCEPT, [
        HeadersEnum.ACCEPT_CART,
        HeadersEnum.ACCEPT_ERROR,
    ].join(','));
    params: HttpParams = new HttpParams();

    constructor(private store: Store<fromApp.AppState>,
        private httpClient: HttpClient,
        private injector: Injector) {

        this.params = this.params.set(ParamsKeys.INCLUDE,
            [ParamsValues.CATALOGUE_ITEMS, ParamsValues.PRICES].join(','))
            .append(ParamsKeys.SORT_BY,
                [
                    ParamsValues.CART_GROUP_TYPE,
                    ParamsValues.CART_GROUP_CREATION_INSTANT,
                    ParamsValues.CREATION_INSTANT_DESC,
                    ParamsValues.CREATION_GRP_INSTANT_DESC].join(','));
    }

    router(): Router {
        return this.injector.get(Router);
    }

    load() {
        return new Promise((resolve, reject) => {
            const cartIdLocalStorage = window.localStorage.getItem(environment.cartId);
            if (isUndefinedOrNull(cartIdLocalStorage)) {
                this.createCart().pipe(
                    take(1))
                    .subscribe(
                        (cart) => {
                            const cartId = cart.id;
                            window.localStorage.setItem(environment.cartId, cartId);
                            this.store.dispatch(new CartActions.CreateCart(cart));
                            resolve(true);
                        },
                        () => {
                            // swallow error so that user is not blocked
                            resolve(false);
                        }
                    );
            } else {
                this.getCart(cartIdLocalStorage)
                    .subscribe(
                        (cart) => {
                            this.store.dispatch(new CartActions.UpdateCart(cart));
                            resolve(true);
                        },
                        (error) => {
                            window.localStorage.removeItem(environment.cartId);
                            this.load().then(
                                () => {
                                    resolve(true);
                                }
                            );
                        }
                    );
            }
        });
    }

    createCart() {
        return this.httpClient.post<CartNode>(this.csCartUrl + 'create-cart', '{}', {});
    }

    getCart(cartId: string) {
        const url = this.csCartUrl + cartId;

        return this.httpClient.get<CartNode>(url,
            {
                params: this.params,
                headers: this.header
            });
    }

}
